import React from 'react';

import { formatLinkProperties } from '~/vendor/cx-web/utils/formatLinkProperties';

import begambleaware from './img/compliance/begambleaware.svg';
import gamblingtherapy from './img/compliance/gambling-therapy.svg';
import gamstop from './img/compliance/gamstop.svg';
import raigSvg from './img/compliance/raig.svg';
import instagram from './img/social/instagram.svg';
import twitter from './img/social/twitter.svg';
import youtube from './img/social/youtube.svg';
import styles from './FooterWS.module.scss';

const standardLinks = [
  {
    title: 'About Us',
    href: 'https://www.whoscored.com/aboutus',
  },
  {
    title: 'Privacy Policy',
    href: 'https://www.whoscored.com/privacy',
  },

  {
    title: 'Contact Us',
    href: 'https://www.whoscored.com/contactus',
  },
  {
    title: 'Terms of Use',
    href: 'https://www.whoscored.com/termsofuse',
  },
];

export const FooterWS = ({ resourcesUrl }: { resourcesUrl: string }): JSX.Element => {
  const links = [...standardLinks];

  return (
    <section className={styles.footerContainer} data-testid="footer-oc">
      <div className={styles.footerWrapper}>
        <div className={styles.footerCenter}>
          <a data-testid="ws-logo-link" {...formatLinkProperties('https://www.whoscored.com/')}>
            <img
              alt="whoscored logo"
              className={styles.footerLogoLink}
              src={`${resourcesUrl}/assets/img/ws-logo.png`}
            />
          </a>
          <div className={styles.footerLinksWrapper}>
            <div className={styles.socialLogosWrapper} data-testid="social-logos">
              <a
                href="https://www.instagram.com/officialwhoscored"
                rel="noopener noreferrer"
                target="_blank"
                title="Instagram"
              >
                <img alt="instagram icon" className={styles.socialIcon} height={40} src={instagram} width={40} />
              </a>
              <a href="https://twitter.com/WhoScored" rel="noopener noreferrer" target="_blank" title="Twitter">
                <img alt="twitter icon" className={styles.socialIcon} height={40} src={twitter} width={40} />
              </a>
              <a href="https://www.youtube.com/whoscored" rel="noopener noreferrer" target="_blank" title="Youtube">
                <img alt="youtube icon" className={styles.socialIcon} height={40} src={youtube} width={40} />
              </a>
            </div>
            <div className={styles.standardLinksContainer} data-testid="general-links">
              <ul className={styles.standardLinksList}>
                {links.map(({ href, title }, idx) => (
                  <li className={styles.standardLinksListItem} key={`${title.toLowerCase()}_${idx}`}>
                    {idx > 0 && <span className={styles.separatorDot}>·</span>}
                    <a className={styles.standardLink} data-testid="general-link" {...formatLinkProperties(href)}>
                      {title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.logosWrapper} data-testid="logo-links">
          <a href="https://www.gamstop.co.uk/" rel="noopener noreferrer" target="_blank" title="GamStop">
            <img alt="gamstop icon" className={styles.gamStop} height={13} src={gamstop} width={54} />
          </a>
          <a href="https://www.begambleaware.org/" rel="noopener noreferrer" target="_blank" title="BeGambleAware">
            <img alt="gamble aware icon" className={styles.gambleAware} height={22} src={begambleaware} width={116} />
          </a>
          <a href="https://www.raig.org/" rel="noopener noreferrer" target="_blank" title="Raig">
            <img alt="raig icon" className={styles.raig} height={18} src={raigSvg} width={55} />
          </a>
          <a
            href="https://www.gamblingtherapy.org/en"
            rel="noopener noreferrer"
            target="_blank"
            title="Gambling Therapy"
          >
            <img
              alt="gambling therapy icon"
              className={styles.gamblingTherapy}
              height={22}
              src={gamblingtherapy}
              width={60}
            />
          </a>
        </div>
      </div>
    </section>
  );
};
